/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidacyProfileEntryUpdate } from '../../axios/candidacyProfileEntryUpdate'
import type {
	CandidacyProfileEntryUpdateError,
	CandidacyProfileEntryUpdatePathParams,
	CandidacyProfileEntryUpdateRequest,
	CandidacyProfileEntryUpdateResponse,
} from '../../types/CandidacyProfileEntryUpdate'

export const candidacyProfileEntryUpdateMutationKey = () =>
	[{ url: '/candidate-center/organisations/:organisation/candidacies/:candidacy/profile/:section/:entry' }] as const

export type CandidacyProfileEntryUpdateMutationKey = ReturnType<typeof candidacyProfileEntryUpdateMutationKey>

export type CandidacyProfileEntryUpdateVariables = {
	organisation: CandidacyProfileEntryUpdatePathParams['organisation']
	candidacy: CandidacyProfileEntryUpdatePathParams['candidacy']
	section: CandidacyProfileEntryUpdatePathParams['section']
	entry: CandidacyProfileEntryUpdatePathParams['entry']
	data: CandidacyProfileEntryUpdateRequest
}

/** @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidacyProfileEntryController.php CandidacyProfileEntryController::update */
export function useCandidacyProfileEntryUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		CandidacyProfileEntryUpdateResponse,
		AxiosError<CandidacyProfileEntryUpdateError>,
		CandidacyProfileEntryUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidacyProfileEntryUpdateMutationKey(),
		mutationFn: ({ organisation, candidacy, section, entry, data }: CandidacyProfileEntryUpdateVariables) =>
			candidacyProfileEntryUpdate(organisation, candidacy, section, entry, data, config).then(res => res.data),
		...options,
	})
}
